export { TutorApplicationChampionTemplate } from "./TutorApplicationChampionTemplate"
export type { TutorApplicationChampionTemplateProps } from "./TutorApplicationChampionTemplate"
